const employeesOptions: SelectItem[] = [
  { value: 'one_to_ten', label: '1 a 10' },
  { value: 'physieleven_to_one_hundredcal', label: '11 a 100' },
  { value: 'one_hundred_to_five_hundred', label: '100 a 500' },
  { value: 'over_five_hundred', label: 'Acima de 500' },
];

export default employeesOptions;
